import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function apiFetch(url: string, options: RequestInit = {}) {
  return fetch(url, {
    cache: 'no-store',
    ...options,
    headers: {
      language: 'vi',
      ...options.headers,
    },
  })
}
